import { render } from "./BaseTable.vue?vue&type=template&id=059d1462"
const script = {}

import exportComponent from "/codebuild/output/src1354205769/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__